import { ButtonContainer, IDataTableColumn } from "nsitools-react";
import React from "react";
import { useHistory } from "react-router";

import { TitleTypeApi, TitleTypeGridDto, TitleTypeSearch } from "../../../../api";
import { EditButton, SearchTablePage, ViewButton } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { ERoutes } from "../../../../ERoutes";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";

export interface ITitleTypeListProps {}

export const TitleTypeList: React.FunctionComponent<ITitleTypeListProps> = () => {
  const api = useApiService(TitleTypeApi);
  const { t } = useTl();
  const history = useHistory();
  const { currentLanguage } = useGlobalData();

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: TitleTypeGridDto) => (
          <ButtonContainer>
            <ViewButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.titleType}/${row.titleTypeId}/detail/view`)}
            />
            <EditButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.titleType}/${row.titleTypeId}/detail/edit`)}
            />
          </ButtonContainer>
        ),
      },
      {
        fieldName: "name",
        header: () => t(ETLCodes.Name),
      },
    ],
    [history, t]
  );

  const addItem = React.useCallback(() => {
    history.push(`${ERoutes.titleType}/${0}/detail/edit`);
  }, [history]);

  const searchCriteriasFunction = React.useCallback(() => api.getSearchCriterias(true), [api]);
  const searchFunction = React.useCallback(
    (sObj) =>
      api.baseSearch(
        TitleTypeSearch.fromJS({
          ...sObj,
          languageId: currentLanguage.languageId,
        })
      ),
    [api, currentLanguage.languageId]
  );
  const exportFunction = React.useCallback(
    (sObj) =>
      api.exportXlsFile(
        TitleTypeSearch.fromJS({
          ...sObj,
          languageId: currentLanguage.languageId,
        })
      ),
    [api, currentLanguage.languageId]
  );

  return (
    <>
      <SearchTablePage
        columns={columns}
        getCriteriasFunction={searchCriteriasFunction}
        searchFunction={searchFunction}
        exportFunction={exportFunction}
        addFunc={addItem}
        breadCrumbs={[{ text: t(ETLCodes.TitleTypes) }]}
        sortKeys={{ name: "ASC" }}
      />
    </>
  );
};
